import React, { useState, Fragment, useEffect, Suspense } from "react"
import { Outlet } from "react-router-dom"
import { useDispatch } from "react-redux"
import clsx from "clsx"

import { PageLoader } from "components"
import { fetchSystemSettings, fetchUserAccountInfo } from "@redux"
import SideNavigation from "./SideNavigation"
import TopNavigation from "./TopNavigation"
import classes from "./index.module.scss"

const Container = () => {
  const dispatch = useDispatch()

  const [openSidebar, setOpenSidebar] = useState(window.innerWidth >= 992)

  useEffect(() => {
    dispatch(
      fetchSystemSettings()
    )

    dispatch(
      fetchUserAccountInfo()
    )
  }, [])

  return (
    <Fragment>
      <TopNavigation
        setOpenSidebar={setOpenSidebar}
      />
      <div
        className={clsx(
          classes["wrapper"],
          openSidebar && classes["open"]
        )}
      >
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </div>
      <SideNavigation
        openSidebar={openSidebar}
      />
    </Fragment>
  )
}

export default Container